export default "__VITE_ASSET__ByypMKCm__"